var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menu.length
    ? _c(
        "div",
        { staticClass: "footer-class-nav container-fluid" },
        [
          _vm.isClassItemPage
            ? [
                +_vm.currentSection === 0
                  ? _c(
                      "a",
                      {
                        staticClass: "class-nav-prev",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goToHome()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-chevron-left fa-2x",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c(
                          "page-icon",
                          _vm._b({}, "page-icon", _vm.homeIconProps, false)
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "hidden-sm hidden-xs name" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.classPage.ClassNav.classPage_classHome"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm.currentSection > 0
                  ? _c(
                      "a",
                      {
                        staticClass: "class-nav-prev",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goToSection(
                              _vm.menu[_vm.currentIndex].FOLDER_ID
                            )
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-chevron-left",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c("page-icon", {
                          attrs: {
                            text: _vm.menu[
                              _vm.currentSection
                            ].FOLDER_NAME.toString().charAt(0),
                            color: _vm.getColor(_vm.currentSection - 1),
                            image: _vm.menu[_vm.currentSection].PAGE_ICON_URL
                              ? "url(" +
                                _vm.menu[_vm.currentSection].PAGE_ICON_URL +
                                ")"
                              : ""
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "hidden-sm hidden-xs name" },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.menu[_vm.currentSection].FOLDER_NAME
                                ) +
                                "\n\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : [
                _vm.currentIndex === 0
                  ? _c(
                      "a",
                      {
                        staticClass: "class-nav-prev",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goToHome()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-chevron-left fa-2x",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c(
                          "page-icon",
                          _vm._b({}, "page-icon", _vm.homeIconProps, false)
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "hidden-sm hidden-xs name" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.classPage.ClassNav.classPage_classHome"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm.currentIndex > 0
                  ? _c(
                      "a",
                      {
                        staticClass: "class-nav-prev",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goToSection(
                              _vm.menu[_vm.prevIndex].FOLDER_ID
                            )
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-chevron-left",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c("page-icon", {
                          attrs: {
                            text: _vm.menu[
                              _vm.prevIndex
                            ].FOLDER_NAME.toString().charAt(0),
                            color: _vm.getColor(_vm.prevIndex),
                            image: _vm.menu[_vm.prevIndex].PAGE_ICON_URL
                              ? "url(" +
                                _vm.menu[_vm.prevIndex].PAGE_ICON_URL +
                                ")"
                              : ""
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "hidden-sm hidden-xs name" },
                          [
                            _vm._v(
                              "\n\t\t\t\t " +
                                _vm._s(_vm.menu[_vm.prevIndex].FOLDER_NAME) +
                                "\n\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                +_vm.currentIndex + 1 < _vm.menu.length
                  ? _c(
                      "a",
                      {
                        staticClass: "class-nav-next",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goToSection(_vm.nextMenuItem.FOLDER_ID)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "hidden-sm hidden-xs name" },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(_vm.nextMenuItem.FOLDER_NAME) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("page-icon", {
                          attrs: {
                            text: _vm.menu[
                              _vm.nextIndex
                            ].FOLDER_NAME.toString().charAt(0),
                            color: _vm.getColor(_vm.nextIndex),
                            image: _vm.menu[_vm.nextIndex].PAGE_ICON_URL
                              ? "url(" +
                                _vm.menu[_vm.nextIndex].PAGE_ICON_URL +
                                ")"
                              : ""
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fas fa-chevron-right fa-2x",
                          attrs: { "aria-hidden": "true" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }